import { routeUrl } from '@actions/route-guard.actions';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { State } from '../reducers';
import { CurrentUserService } from './current-user.service';

@Injectable()
export class RequireAcceptedTermsOfServicesGuard {
  constructor(private currentUserService: CurrentUserService, private router: Router, private store: Store<State>) {}

  canActivate(activeSnapshot: ActivatedRouteSnapshot, routerSnapshot: RouterStateSnapshot) {
    return this.currentUserService.user$.pipe(
      map((user) => {
        const hasPendingTerms = user.pendingTermsOfServices.length > 0;
        const isTermsOfServicePage = routerSnapshot.url.startsWith('/user/terms-of-service');
        const userIsBeingImpersonated = user.impersonatedBy !== null;

        if (hasPendingTerms && !isTermsOfServicePage && !userIsBeingImpersonated) {
          this.store.dispatch(routeUrl({ routeUrl: routerSnapshot.url }));
          this.router.navigate(['/user/terms-of-service']);
          return false;
        } else {
          this.store.dispatch(routeUrl({ routeUrl: null }));
          return true;
        }
      })
    );
  }
}
